var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLiveSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#868E96",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.033 14.71c.944 0 1.717-.724 1.717-1.61H5.315c0 .886.773 1.61 1.718 1.61zm5.153-4.002V6.682c0-2.472-1.4-4.542-3.865-5.09-.57-.11-1-.165-1.288-.165-.29 0-.719.055-1.289.166C3.288 2.14 1.88 4.202 1.88 6.682v4.026l-1.717 1.61v.805h13.742v-.805l-1.718-1.61zm-1.718.805h-6.87V6.682c0-1.997 1.296-3.624 3.435-3.624 2.138 0 3.435 1.627 3.435 3.624v4.83z",
    transform: "translate(-284 -1862) translate(24 1857) translate(260 5)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLiveSchedule);
export default __webpack_public_path__ + "static/media/ic_live_schedule.110c5415db73d1d242191c65bef87d23.svg";
export { ForwardRef as ReactComponent };